<template>
    <div class="home" id="cisRsi">
        <div class="tsKampagnenBox">
            <div class="btnAll"><DxButton :text="btn.SelectSuchfeldBtnCards" @click="showAllSuchfelder" /><span class="btnAllTxt">{{tx.SelectSuchfeldCaptionCards}}</span></div>
       
            <div v-for="data in openRoundList" :key="data.RouId" class="tsFor">
                <div v-if="data.Suchfelder.length > 0" class="tsKampagne">
                    <div class="tsHeader">
                        <div class="tsKampagneTitle" v-if="data.RouName.length == 0">
                            {{ data.RouName }}
                        </div>
                    </div>
                    <div class="tsSuchfeldBox">
                        <div v-for="rec in data.Suchfelder" :key="rec.LitId" class="tsFor tsForIn">
                            <div class="tsSuchfeld" @click="selectSuchfeld(rec.LitId, data.RouId, rec.Title)">
                                <div class="tsSuchfeldTitle">
                                    {{ rec.Title }}
                                </div>
                                <div class="tsSuchfeldImage">
                                    <img :src="rec.SufImageUri" />
                                </div>
                                <div class="tsSuchfeldDescription">
                                    <span v-html="rec.Description" />
                                </div>
                            </div>
                            <div class="tsButton">
                                <DxButton class="tsBtnDx" :text="btn.SelectBtnCards" @click="selectSuchfeld(rec.LitId, data.RouId)" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { DxButton } from 'devextreme-vue/button'
    export default {
        name: 'RssFeedIntro',
        components: {
            DxButton
        },
        data() {
            return {
                rouIdSel: this.rouId,
                litIdSel: this.litId,
                btn: {
                    SelectSuchfeldBtnCards: this.$LanguageProvider.GetResource("SelectSuchfeldBtnCards", "Caption", "Alle Suchfelder"),
                    SelectBtnCards: this.$LanguageProvider.GetResource("SelectBtnCards", "Caption", "Auswählen"),
                },
                tx: {
                    SelectSuchfeldCaptionCards: this.$LanguageProvider.GetResource("SelectSuchfeldCaptionCards", "Caption", "oder wählen Sie ein Suchfeld aus:"),
                }
            }
        },
        computed: {
            openRoundList() {
                //var result = this.$store.state.roundStore.openRoundList;
                //if (result.length != 0) {
                //    var i = 0;
                   
                //    result[0].Suchfelder.forEach(sf => {
                //         //Suchfelder Übersetzung
                //        sf.Title = this.$LanguageProvider.GetResource("Suchfeld" + i, "Title", sf.Title)
                //        sf.Description = this.$LanguageProvider.GetResource("Suchfeld" + i, "Description", sf.Description)
                //        i++;
                //    })}
               
           
                return this.$store.state.roundStore.openRoundList
            },
        },
        props:
            ["rouId", "litId"]
        ,
        mounted() {
            this.$store.dispatch("getOpenRoundListWithSuchfelder")
        },
        watch: {
        },
        methods: {
            selectSuchfeld(litId, rouId, suchfeldName) {
                this.$emit("selected", { litId: litId, rouId: rouId, suchfeldName: suchfeldName })
            },
            showAllSuchfelder() {
                this.$emit("selected", { litId: 0, rouId: 0, suchfeldName: this.$LanguageProvider.GetResource("SelectSuchfeldBtnCards", "Caption", "Alle Suchfelder") })
            }
        }

    }

</script>
<style scoped>
    .tsForIn {
        border: solid 1px #ebebeb;
        margin: 5px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
    }


    .tsSuchfeldDescription {
        padding-top: 10px;
        font-size: var(--grid-suchfeld-description-size);
        color: var(--grid-suchfeld-description-color);
    }

    .tsSuchfeldTitle {
        min-height: 35px;
        /*  padding: 6px 6px 0 15px;*/
        font-size: var(--grid-suchfeld-title-size);
        color: var(--grid-suchfeld-title-color);
        font-weight: bold;
    }

    .tsKampagneTitle {
        font-size: 20px;
        font-weight: bold;
        padding-left: 15px;
    }

    .tsSuchfeldImage {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 3%;
        padding: 0
    }

    .tsHeader {
        display: flex;
        width: 100%;
        grid-column-gap: 10px;
        float: left;
        clear: both;
        max-width: initial;
    }

        .tsHeader img {
            max-width: 100%;
            padding: 10px;
        }

    .tsSuchfeldImage img {
        width: 100%;
        object-fit: cover;
        height: 225px;
    }

    .tsSuchfeld {
        padding: 15px;
    }


    .tsSuchfeldBox {
        display: grid;
        gap: 30px;
        grid-template-columns: repeat(auto-fit, 400px);
        padding: 10px;
    }

    .tsFor.tsForIn {
        cursor: pointer;
    }

        .tsFor.tsForIn:hover {
            background-color: whitesmoke;
        }

    .btnAllTxt {
        padding-left: 10px;
    }

    .tsButton {
        margin-top: 15px;
        display: flex;
        justify-content: center;
        padding-bottom: 14px;
    }

    .tsForIn:hover {
        box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 15%);
    }

    .tsBtnDx {
        width: 95%;
    }



    .tsKampagneImage {
        width: 100px;
    }
     

    .btnAll {
        margin: 15px;
    }
</style>
